/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CheckCircleSolid from './check-circle-solid-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CheckCircleSolid {...validProps} />;
}

SvgComponent.iconName = 'checkCircleSolid';

export const CheckCircleSolidIcon = svgIconWrapper(SvgComponent);
